import { Component, Injector } from '@angular/core';
import { combineLatest, Observable, of } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { catchError, map, takeUntil } from 'rxjs/operators';
import {
  BaseResourceListComponent, Exercicio, LoginPublico,
  ExercicioService, Filtro, Cargo, Coluna, MapaRotasTransparenciaService, RotaTransparencia
} from 'eddydata-lib';
import { DatePipe } from '@angular/common';
import { TransparenciaTituloDescricaoQuadroService } from '../transparencia-titulo-descricao-quadro/service/transparencia-titulo-descricao-quadro.service';
import { GrupoArquivoTransparenciaService } from '../transparencia-arquivo/service/grupo-arquivo-transparencia.service';
import { TransparenciaInformacaoAdicionalGrupoService } from '../transparencia-informacao-adicional/transparencia-informacao-adicional-form/service/transparencia-informacao-adicional-grupo.service';

@Component({
  selector: 'app-transparencia-pesquisa',
  templateUrl: './transparencia-pesquisa.component.html'
})
export class TransparenciaPesquisaComponent extends BaseResourceListComponent<Exercicio, LoginPublico> {
  /**
   * Declaração de variáveis
   */
  public data1: string;
  public data2: string;
  public datepipe: DatePipe;
  public listaGeral: RotaTransparencia[] = [];
  public listaRotas: RotaTransparencia[] = [];

  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    private route: ActivatedRoute,
    protected injector: Injector,
    private exService: ExercicioService,
    protected mapaRotasServico: MapaRotasTransparenciaService,
    protected tituloDescricaoService: TransparenciaTituloDescricaoQuadroService,
    protected grupoArquivoService: GrupoArquivoTransparenciaService,
    protected informacaoAdicionalGrupoService: TransparenciaInformacaoAdicionalGrupoService,
  ) {
    super(exService, injector);
    this.datepipe = new DatePipe('pt');
  }

  // ========================================================================
  //                        MÉTODOS ABSTRAÍDOS
  // ========================================================================

  protected relations(): string {
    return 'cidade';
  }

  protected condicoesGrid(): {} {
    return {
      ['cidade.id']: this.login.cidade.id
    };
  }

  protected ordenacaoGrid(): string[] {
    return ['id$ASC'];
  }

  protected filtrosGrid(): Filtro {
    return {
    };
  }

  protected afterInit(): void {
    this.login.contraste = sessionStorage.getItem('contraste') === 'true';

    const titulos$ = this.tituloDescricaoService.obter({ 'orgao.id': this.login.orgao.id, relations: 'orgao' })
      .pipe(catchError(() => of(null)));

    const gruposArquivo$ = this.grupoArquivoService.filtrar(1, -1, { 'orgao.id': this.login.orgao.id, relations: 'orgao' })
      .pipe(
        map(res => res.content || []),
        catchError(() => of([]))
      );

    const informacoesAdicionais$ = this.informacaoAdicionalGrupoService.filtrar(1, -1, { 'orgao.id': this.login.orgao.id, relations: 'orgao' })
      .pipe(
        map(res => res.content || []),
        catchError(() => of([]))
      );

    combineLatest([this.route.params, titulos$, gruposArquivo$, informacoesAdicionais$])
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(([params, titulos, gruposArquivo, informacoesAdicionais]) => {
        const filtro = params.filtro || '';

        this.listaRotas = this.mapaRotasServico.buscarRotaTransparencia(titulos, gruposArquivo, informacoesAdicionais);
        this.listaGeral = this.mapaRotasServico.filtrarRotas(this.listaRotas, filtro);
      });
  }

  protected acaoRemover(model: Cargo): Observable<Cargo> {
    return null;
  }

  protected colunasRelatorio(): string[] | Coluna[] {
    return [
    ];
  }

  public imprimirPDF() {
  }

  // ========================================================================
  //                            MÉTODOS DA CLASSE
  // ========================================================================

  public buscar(item: RotaTransparencia) {
    if (!item.rota) {
      return;
    }

    if (item.externo) {
      window.open(item.rota, '_blank', 'noopener');
      return;
    }

    this.router.navigate([item.rota]);
  }
}
